import React from 'react';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

interface RewardiouLogoProps {
  height?: number;
  width?: number;
}

const logoSrc = `${process.env.PUBLIC_URL || ''}/assets/brand/rewardiou-mark.svg`;

const RewardiouLogo: React.FC<RewardiouLogoProps> = ({ height = 44, width = 44 }) => {
  const navigate = useNavigate();

  return (
    <Box
      component="button"
      type="button"
      aria-label="Rewardiou home"
      onClick={() => navigate('/')}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 0,
        mr: 1.5,
        border: 0,
        bgcolor: 'transparent',
        cursor: 'pointer',
      }}
    >
      <Box component="img" src={logoSrc} alt="Rewardiou Logo" sx={{ width, height, display: 'block' }} />
    </Box>
  );
};

export default RewardiouLogo;
